module.exports = __webpack_public_path__ + "media/navigation/icon-question-mark-54493532.svg";